import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';

import SignUp from '../login/pages/signup';
import VerifySignInOTP from '../login/pages/mobile-otp';
import SignIn from '../login/pages/signin';
import GetStarted from '../login/pages/get-started';
import EmailOTP from '../login/pages/email-otp';
import ForgotPassword from '../login/pages/forgot-password';
import SetPassword from '../login/pages/set-password';
import VerifyPassword from '../login/pages/verify-password';
import EmailVerification from '../login/pages/email-verification';
import SettingUp from '../post-login/pages/setting-up';
import TeamAccounts from '../post-login/pages/team-accounts';
import MobileSet from '../login/pages/set-email-only-mobile'
import { emailRegex } from '../shared/services/validations';
import config from '../shared/services/config'
import { fetchUser, fetchHubApiToken } from '../shared/actions/auth';
import EmailonlyOTPVerification from '../login/pages/email-only-mobile-otp-verification'
import AuthManager from '../shared/services/AuthManager';
import EmailOnlyEmailVerification from '../login/pages/email-only-email-verification'
import 'url-search-params-polyfill';
import { Outlets } from '../post-login/pages/outlets';

class AuthRoutes extends React.PureComponent {

  async componentWillMount() {
    let queryParams = window.location.search;
    queryParams = queryParams.replace(/[^=&]+=(&|$)/g, '').replace(/&$/, '');
    if (Boolean(queryParams)) {
      queryParams = queryParams.charAt(0) === '?' ? queryParams : `?${queryParams}`;
      //Append Partner UUID for OAuth 
      const partner_uuid = new URLSearchParams(window.location.search).get('reseller_id');
      queryParams = queryParams + (queryParams.includes('partner_uuid') ? '' : `&partner_uuid=${partner_uuid}`)
      sessionStorage.setItem('queryString', queryParams);
    } else {
      let queryString = sessionStorage.getItem('queryString');
      /** parsedQueryString.toString() is BUGGY, it does not parse URI correctly
       * toString() is converting https://payumoney.com/ to https%3A%2F%2Fpp42.payumoney.com%2F
       * const parsedQueryString = new URLSearchParams(queryString);
       * parsedQueryString.delete('invitation_code');
       * sessionStorage.setItem('queryString', `?${parsedQueryString.toString()}`);
       * below code implements same logic without URLSearchParams
       * */
      // remove invitation code key-value params & store rest in storage
      if (queryString) {
        queryString = queryString.split('&').filter((x) => !x.match(/invitation_code/)).join('&');
      }
      sessionStorage.setItem('queryString', queryString);
    }
    await fetchHubApiToken();
    const email = new URLSearchParams(window.location.search).get('email');
    if (!!!emailRegex(email)) {
      fetchUser(this.props.dispatch, { email });
    }
    if (AuthManager.getAppToken()) {
      const isPartner = config.get('product') === 'PARTNER' && true;
      if(isPartner) {
        window.location.assign('/app/manage_account');
      }
      if (!(this.props.history.location.pathname.indexOf('/account/team-accounts') >=0))
        this.props.history.push({
          pathname: '/account/team-accounts'
        })
    }
  }

  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route
          path={`${match.path}/signup`}
          component={
            config.get('disableOnboarding')
            ? (
              () => {
                useEffect(() => {
                  window.location.href = 'https://lp.payu.in/onboarding'
                }, [])
                return <>...</>
              }
            ) : SignUp
          }
        />
        <Route 
          path={`${match.path}/get-started`}
          component={GetStarted}
        />
        <Route
          path={`${match.path}/mobile_otp`}
          component={VerifySignInOTP}
        />
        <Route
          path={`${match.path}/signin`}
          component={SignIn}
        />
        <Route
          path={`${match.path}/email_otp`}
          component={EmailOTP}
        />
        <Route
          path={`${match.path}/forgot_password`}
          component={ForgotPassword}
        />
        <Route
          path={`${match.path}/set-password`}
          component={SetPassword}
        />
        <Route
          path={`${match.path}/set-mobile`}
          component={MobileSet}
        />
        <Route
          path={`${match.path}/verify-password`}
          component={VerifyPassword}
        />
        <Route
          path={`${match.path}/email/otp`}
          component={props => (
            <EmailVerification
              {...props}
              pageHeading="Enter OTP sent to your email"
            />
          )}
        />
        <Route path={`${match.path}/setting-up`} component={SettingUp} />
        <Route path={`${match.path}/team-accounts/:mid/outlets`} component={Outlets}/>
        <Route path={`${match.path}/team-accounts`} component={TeamAccounts} />
        <Route path={`${match.path}/mobile/otp`} component={EmailonlyOTPVerification} />
        <Route path={`${match.path}/email/verify`} component={EmailOnlyEmailVerification} />
        <Redirect path={match.path} to="/account/signin" />
      </Switch>
    );
  }
}

export default connect()(AuthRoutes);